// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Domain$ReactHooksTemplate = require("../general_settings/domain.res.js");
var DomainCreate$ReactHooksTemplate = require("../general_settings/DomainCreate.res.js");

function reducer(param, action) {
  if (typeof action !== "object") {
    return "InvalidDomain";
  } else {
    return {
            TAG: "Available",
            _0: action._0
          };
  }
}

function fetchDomain(id) {
  var url = "/api/v1/domains/" + String(Belt_Option.getExn(id));
  return Http$ReactHooksTemplate.fetchGetJSONDecode(url, (function (param) {
                return Json_decode.field("domain", Domain$ReactHooksTemplate.decode, param);
              }));
}

function DomainEdit(props) {
  var domainId = props.domainId;
  var match = React.useReducer(reducer, "FetchingDomains");
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function (param) {
          Js_promise.then_((function (domain) {
                  return Promise.resolve(Curry._1(dispatch, {
                                  TAG: "FetchedDomain",
                                  _0: domain
                                }));
                }), fetchDomain(domainId));
        }), []);
  if (typeof state !== "object") {
    if (state === "FetchingDomains") {
      return JsxRuntime.jsx("p", {
                  children: "Loading domains"
                });
    } else {
      return JsxRuntime.jsx("p", {
                  children: "No domain found"
                });
    }
  } else {
    return JsxRuntime.jsx(DomainCreate$ReactHooksTemplate.make, {
                domain: Caml_option.some(state._0),
                handleAlert: props.handleAlert,
                handleReturn: props.handleReturn
              });
  }
}

var make = DomainEdit;

exports.reducer = reducer;
exports.fetchDomain = fetchDomain;
exports.make = make;
/* react Not a pure module */
